export class SimulationAnalysis {
  public creation_date: Date;
  public inception_date: Date;
  public last_date: Date;

  public parameters: any;
  public unprotected: any;
  public aggressiveness: any;
  public maximum_loss: any;
  public maximum_drawdown: any;
  public protection_horizon: any;

  constructor() {}

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.creation_date      = data.creation_date ? new Date(data.creation_date) : undefined;
    this.inception_date     = data.inception_date ? new Date(data.inception_date) : undefined;
    this.last_date          = data.last_date ? new Date(data.last_date) : undefined;

    this.parameters         = data.parameters ? data.parameters : undefined;
    this.unprotected        = data.unprotected ? data.unprotected : undefined;
    this.aggressiveness     = data.aggressiveness ? data.aggressiveness : undefined;
    this.maximum_loss       = data.maximum_loss ? data.maximum_loss : undefined;
    this.maximum_drawdown   = data.maximum_drawdown ? data.maximum_drawdown : undefined;
    this.protection_horizon = data.protection_horizon ? data.protection_horizon : undefined;
  }
}
